module.exports = __webpack_public_path__ + "static/media/garph-line.c3fce82a.svg";